import React from 'react';
import { Card, List } from 'antd';
import ProjectDescription from './ProjectDescription';
import VerifiedWhatsappNotification from '../VerifiedWhatsappNotification';

const ProjectHistory = ({ passport }) => {
  const { projects } = passport;
  return (
    <Card className="gx-card" title={`Riwayat Bekerja di Proyek`}>
      {passport.whatsapp.result.visible && !passport.actions.verification ? <VerifiedWhatsappNotification passport={passport} /> : null}
      <List
        itemLayout="horizontal"
        dataSource={projects}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={`${item.project.name} (${item.project.code})`}
              description={<ProjectDescription item={item} passport={passport} />}
            />
          </List.Item>
        )}
      />
    </Card>
  );
}

export default ProjectHistory;